import gql from 'graphql-tag'
import {
	user as userFragment,
	permissions as permissionsFragment
} from './fragments'

export const user = gql`
mutation updateUser_Main($id: ID!, $fields: UserFields!) {
	cashAssist {
		updateUser(id: $id, fields: $fields) {
			id
			mod_ver
			...usermain
		}
	}
}
${userFragment}`

export const cashRegisters = gql`
mutation updateUser_cashRegisters($id: ID!, $fields: UserFields!) {
	cashAssist {
	  updateUser(id: $id, fields: $fields) {
	    id
	    mod_ver
	    cashRegisterId
	  }
	 }
}`

export const permissions = gql`
mutation updateUser_Permissions($id: ID!, $fields: UserFields!) {
	cashAssist {
		updateUser(id: $id, fields: $fields) {
			id
			mod_ver
			...permissions
		}
	}
}
${permissionsFragment}`

export const waiterKey = gql`
mutation updateUser_WaiterKey($id: ID!, $fields: UserFields!) {
	cashAssist {
		updateUser(id: $id, fields: $fields) {
			id
			mod_ver
			waiterKey
		}
	}
}`

export const monthlyTaxFreeAmount = gql`
mutation updateUser_MonthlyTaxFreeAmount($id: ID!, $fields: UserFields!) {
	cashAssist {
		updateUser(id: $id, fields: $fields) {
			id
			mod_ver
			monthlyTaxFreeAmount
		}
	}
}`

export default {
	user,
	cashRegisters,
	permissions,
	waiterKey,
	monthlyTaxFreeAmount
}
